/* eslint-disable @typescript-eslint/no-explicit-any */
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { format } from "date-fns";
import { ptBR } from "date-fns/locale";

const TAX_TYPE_TRANSLATIONS: { [key: string]: string } = {
  CREATION: "Criação",
  UPDATE: "Atualização",
  DELETE: "Exclusão",
};

export function ModalNFFDetails({ requestData }: { requestData: any }) {
  return (
    <div className="space-y-6">
      <div className="grid grid-cols-2 gap-6">
        <div className="flex flex-col gap-2">
          <Label className="text-lg">Email</Label>
          <Input
            value={requestData.email}
            disabled
            className="bg-gray-100 h-12 text-lg"
          />
        </div>

        <div className="flex flex-col gap-2">
          <Label className="text-lg">Responsável</Label>
          <Input
            value={requestData.responsible}
            disabled
            className="bg-gray-100 h-12 text-lg"
          />
        </div>
      </div>

      <div className="grid grid-cols-2 gap-6">
        <div className="flex flex-col gap-2">
          <Label className="text-lg">Tipo de Solicitação</Label>
          <Input
            value={
              TAX_TYPE_TRANSLATIONS[requestData.tax_type_request] ||
              requestData.tax_type_request
            }
            disabled
            className="bg-gray-100 h-12 text-lg"
          />
        </div>

        <div className="flex flex-col gap-2">
          <Label className="text-lg">Tipo Fiscal</Label>
          <Input
            value={requestData.type}
            disabled
            className="bg-gray-100 h-12 text-lg"
          />
        </div>
      </div>

      <div className="grid grid-cols-2 gap-6">
        <div className="flex flex-col gap-2">
          <Label className="text-lg">Período NFF</Label>
          <Input
            value={
              requestData.nff_values?.results?.length > 0 &&
                requestData.nff_values.results[0]?.payment_date
                ? format(
                  new Date(requestData.nff_values.results[0].payment_date),
                  "dd/MM/yyyy",
                  { locale: ptBR }
                )
                : (
                  requestData.nff_values?.startDate &&
                  requestData.nff_values?.endDate
                )
                  ? `${format(new Date(requestData.nff_values.startDate), "dd/MM/yyyy", { locale: ptBR })} - ${format(new Date(requestData.nff_values.endDate), "dd/MM/yyyy", { locale: ptBR })}`
                  : "Período não disponível"
            }
            disabled
            className="bg-gray-100 h-12 text-lg"
          />
        </div>

        <div className="flex flex-col gap-2">
          <Label className="text-lg">Criado em</Label>
          <Input
            value={format(
              new Date(requestData.created_at),
              "dd/MM/yyyy HH:mm:ss",
              {
                locale: ptBR,
              }
            )}
            disabled
            className="bg-gray-100 h-12 text-lg"
          />
        </div>
      </div>

      <div className="flex flex-col gap-4">
        <Label className="text-lg">Notas Fiscais</Label>
        <div className="border rounded-lg p-4 max-h-60 overflow-y-auto bg-gray-50 shadow-md">
          {requestData.nff_values?.invoices?.length > 0 ? (
            requestData.nff_values.invoices.map(
              (invoice: any, index: number) => (
                <div
                  key={index}
                  className="flex justify-between items-center p-3 border-b last:border-none"
                >
                  <span className="text-base font-medium">
                    {invoice.invoiceNumber}
                  </span>
                  <span
                    className={`text-sm font-semibold px-3 py-1 rounded-md ${invoice.status === "FAILED"
                      ? "bg-red-200 text-red-700"
                      : "bg-green-200 text-green-700"
                      }`}
                  >
                    {invoice.status === "FAILED" ? "Falha" : "Sucesso"}
                  </span>
                </div>
              )
            )
          ) : requestData.nff_values?.results?.length > 0 ? (
            requestData.nff_values.results.map(
              (invoice: any, index: number) => (
                <div
                  key={index}
                  className="flex justify-between items-center p-3 border-b last:border-none"
                >
                  <span className="text-base font-medium">
                    {invoice.invoiceNumber}
                  </span>
                  <span
                    className={`text-sm font-semibold px-3 py-1 rounded-md ${invoice.status === "FAILED"
                      ? "bg-red-200 text-red-700"
                      : "bg-green-200 text-green-700"
                      }`}
                  >
                    {invoice.status === "FAILED" ? "Falha" : "Sucesso"}
                  </span>
                </div>
              )
            )
          ) : (
            <p className="text-gray-500 text-lg">
              Nenhuma nota fiscal disponível.
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
